/**
 * 
 * key
 * 
 */


const key = 'ZGVsaXZlcmFibGVfcHJvZHVjdF9jYXRlZ29yeQ=='

export default key 